const roles = [
    {
        slug: "ceo",
        title: "CEO",
        label: "Chief Executive Officer",
        tagline: "You lead. You pitch. You set the direction.",
        description:
            "The CEO keeps the team aligned, owns the company vision, and makes the calls when it's unclear. The CEO ensures shipment is punctual.",
        detailBlurb: [
            "You are the founder of this company for the duration of the program. That means setting the strategic direction, facilitating team decisions, and carrying the weight of the outcome.",
            "Your Startup Trainer will push you on your thinking. They've raised capital, shipped products, and led teams — and they'll hold you to that standard. You're not playing startup. You're running one.",
            "By the end of the sprint, you'll have led a team through a full product launch. You'll know what it means to own something — and what it costs to cut corners.",
        ],
        owns: ["Company direction & strategy", "Team alignment & standups", "Investor pitch & final demo", "Launch decision"],
    },
    {
        slug: "cmo",
        title: "CMO",
        label: "Chief Marketing Officer",
        tagline: "You own the story. The launch. The reach.",
        description:
            "The CMO ensures the world knows what the team has made. The CMO ensures brand growth acceleration in the online world.",
        detailBlurb: [
            "Marketing at Extern Academy isn't PowerPoints about target demographics. You'll define a real positioning statement, build a real launch strategy, and execute it against a real deadline.",
            "You'll own the narrative from day one — working alongside the CPO to understand who the user is and crafting a message that lands. Then you'll go execute: landing pages, social presence, launch copy, the works.",
            "By demo day, you'll have a live go-to-market campaign behind you. That's something you can show.",
        ],
        owns: ["Brand positioning & messaging", "Go-to-market strategy", "Launch campaigns & channels", "Demo day narrative"],
    },
    {
        slug: "cto",
        title: "CTO",
        label: "Chief Technology Officer",
        tagline: "You own the stack. The build. The ship date.",
        description:
            "Architecture decisions, technical tradeoffs, code quality, and shipping on time — the CTO turns the product vision into a working, launched product.",
        detailBlurb: [
            "The CTO role isn't about having the right answers at the start. It's about making good technical decisions fast, communicating them to a non-technical team, and executing under pressure.",
            "You'll pick the stack, set up the repo, establish dev standards, and own every line of code that goes into the final product. When something breaks at 11pm before demo day, that's on you to fix.",
            "Your Startup Trainer has shipped products. They'll push you on your architectural choices and call out decisions that won't scale. This is the most rigorous technical feedback most high schoolers will ever get.",
        ],
        owns: ["Technical architecture & stack", "Engineering execution & code quality", "Dev environment & deployment", "Technical demo"],
    },
    {
        slug: "cpo",
        title: "CPO",
        label: "Chief Product Officer",
        tagline: "You own the roadmap. The user. The decisions.",
        description:
            "The CPO listens to what users need, selects which features matter most, and ensures the final product is excellent.",
        detailBlurb: [
            "Product is the connective tissue of the company. You'll work with the CEO on strategy, with the CTO on what's buildable, with the CMO on what the market wants — and then you'll synthesize it all into a roadmap that the team can execute.",
            "You'll write the specs. You'll run user interviews. You'll make the call on what's in scope and what gets cut. Every time the team debates whether to build Feature A or Feature B, you're the one who decides — and defends it.",
            "By the end, you'll have shipped a product that real users can interact with. You'll know exactly which decisions you'd make differently.",
        ],
        owns: ["Product roadmap & feature prioritization", "User research & specs", "Cross-functional alignment", "Product decisions & tradeoffs"],
    },
    {
        slug: "coo",
        title: "COO",
        label: "Chief Operating Officer",
        tagline: "You own the execution. The timeline. The systems.",
        description:
            "The COO makes sure every piece moves without friction from kickoff all the way to launch day.",
        detailBlurb: [
            "Operations is the role that holds everything together. You'll own the team calendar, the sprint structure, the meeting cadence — and you'll be the first one to notice when something is slipping.",
            "Great COOs are ruthless about clarity: who's doing what, by when, and what's blocking them. That's the job. When the team is underwater two days before demo, you're the one who calls what gets cut and what gets done.",
            "This role requires zero ego. You're not building the flashiest feature — you're making it possible for everyone else to build anything at all.",
        ],
        owns: ["Sprint planning & standups", "Team coordination & unblocking", "Timeline & milestone tracking", "Process & documentation"],
    },
    {
        slug: "cgo",
        title: "CGO",
        label: "Chief Growth Officer",
        tagline: "You own the numbers. The channels. The traction.",
        description:
            "The CGO figures out how to put the product in front of real users and makes the metrics move.",
        detailBlurb: [
            "Growth at Extern Academy is not a hypothetical exercise. You'll identify real distribution channels, run real experiments, and measure actual results against a product that's live by the end of the sprint.",
            "You'll work closely with the CMO on launch strategy and with the CPO on understanding what user behavior the product needs to drive. Then you'll go find the users, get them in, and figure out how to keep them.",
            "This role rewards people who are uncomfortable with soft metrics. If you can't put a number on it, it doesn't count. By demo day, you'll have a growth story grounded in actual data.",
        ],
        owns: ["Acquisition strategy & channels", "User growth experiments", "Retention & engagement metrics", "Growth data & reporting"],
    },
];

export default roles;
